module.exports = __webpack_public_path__ + "img/blankscreen_1000.feac42cd.jpg";